import { render } from "./ReportsTable.vue?vue&type=template&id=4dbcb986&scoped=true"
import script from "./ReportsTable.vue?vue&type=script&lang=js"
export * from "./ReportsTable.vue?vue&type=script&lang=js"

import "./reports-table.scss?vue&type=style&index=0&id=4dbcb986&lang=scss&scoped=true"

import exportComponent from "/srv/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dbcb986"]])

export default __exports__